import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import BoldText from "../../common/text/BoldText";
import LabeledText from "../../common/text/LabeledText";

class SafeInfoModal extends React.Component {

  render() {
    const {intl: {formatMessage}, onModalClose, visible, safeInfo} = this.props;

    if (!safeInfo) {
      return null;
    }

    const {customer, userVehicle, rentalVehicle} = safeInfo;
    return (
      <Modal title={formatMessage({id: 'section.safes-planning.modal.title'})}
             visible={visible} onCancel={onModalClose} footer={null}>

        <div className="row">
          <ul className="list col-md-6 col-xxl-6">
            <h3 className="box__subtitle">{formatMessage({id:'summary.customer'})}</h3>
            <li><LabeledText label={'summary.customer'} text={`${customer.firstName} ${customer.lastName}`}/></li>
            <li><LabeledText label={'summary.phone'} text={customer.phone}/></li>
            <li><LabeledText label={'vehicle.make'} text={userVehicle.brand}/></li>
            <li><LabeledText label={'vehicle.model'} text={userVehicle.model}/></li>
            <li><LabeledText label={'vehicle.vin'} text={<BoldText text={userVehicle.vin} boldEndCharacters={7}/>}/></li>
            <li><LabeledText label={'vehicle.plate'} text={userVehicle.licensePlate}/></li>
          </ul>

          {rentalVehicle &&
            <ul className="list col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id:'mobility.rental-car'})}</h3>
              <li><LabeledText label={'vehicle.make'} text={rentalVehicle.brand}/></li>
              <li><LabeledText label={'vehicle.model'} text={rentalVehicle.model}/></li>
              <li><LabeledText label={'vehicle.vin'} text={<BoldText text={rentalVehicle.vin} boldEndCharacters={7}/>}/></li>
              <li><LabeledText label={'vehicle.category'} text={formatMessage({id: `mobility.${rentalVehicle.category}`})}/></li>
              <li><LabeledText label={'vehicle.gearbox'} text={formatMessage({id: `vehicle.gearbox.${rentalVehicle.gearbox}`})}/></li>
              <li><LabeledText label={'vehicle.plate'} text={rentalVehicle.licensePlate}/></li>
            </ul>
          }
        </div>
      </Modal>
    )
  }
}

export default injectIntl(SafeInfoModal);



// WEBPACK FOOTER //
// ./src/components/safes/planning/SafeInfoModal.js